<template>
  <div class="modal-Device">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">设备详情</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <template>
          <el-table
              :data="tableData"
              :height="400"
              border
              style="width: 100%;"
              v-loading="loading">
            <el-table-column prop="name" label="设备名称"  ></el-table-column>
            <el-table-column prop="isManage" :formatter="getIsManage" label="绑定状况"></el-table-column>
            <el-table-column prop="keyType" label="设备号类型"></el-table-column>
            <el-table-column prop="deviceNum" label="设备号"></el-table-column>
          </el-table>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "PageForDevice",
  data() {
    return {
      qZXueTangYiDataShow:false,
      lXXueYaJiDataPageShow:false,
      wangGuanDataShow:false,
      addLXXueYaJiPageShow:false,
      sBJDataShow:false,
      watchDataShow:false,
      showModalSOSSetPage:false,
      showModalMeshDevicePage:false,
      showModalAddDevice: false,
      userCode: '',
      tableData: '',
      loading: false,
      name: '',
      deviceName:'',


    }
  },
  components: {
  },

  methods: {
    init(row) {
      this.userCode = row.userCode;
      this.getInfo();
    },

    closeSelf() {
      this.$emit("closeDevice");
    },
    getIsManage(row) {
      if (row.isManage === 0) {
        return '未绑定';
      }
      else if (row.isManage === 1) {
        return '已绑定';
      }
      else if (row.isManage === 2) {
        return '已解绑';
      }else {
        return '未绑定';
      }

    },
    bind(index, row) {
      if(row.name==='血压计'){
        this.$refs.AddLXXueYaJiPage.init(this.userCode,row);
        this.addLXXueYaJiPageShow =!this.addLXXueYaJiPageShow;
      }else {
        this.$refs.myAddDevice.init(this.userCode, row);
        this.showModalAddDevice = !this.showModalAddDevice;
      }
    },

    getInfo() {
      this.loading = true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + 'UserDevice/GetInfo',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userCode: this.userCode,
          plateform:'shop'
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error === 0) {
          this.tableData = response.data.data;
        }
      })

    },



  }


}
</script>

<style lang="scss" scoped>

.modal-Device {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}

</style>